
import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingIndicatorProps {
  variant?: 'skeleton' | 'refresh' | 'inline';
  message?: string;
  className?: string;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  variant = 'skeleton',
  message = 'Loading...',
  className,
}) => {
  if (variant === 'refresh') {
    return (
      <div className={cn(
        "flex items-center justify-center py-2 text-sm text-muted-foreground",
        "",
        className
      )}>
        <Loader2 className="h-4 w-4 animate-spin mr-2" />
        <span>Updating availability...</span>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div className={cn(
        "flex items-center gap-2 text-sm text-muted-foreground",
        className
      )}>
        <Loader2 className="h-4 w-4 animate-spin" />
        <span>{message}</span>
      </div>
    );
  }

  // Enhanced skeleton variant with better visual hierarchy
  return (
    <div className={cn("", className)}>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="h-6 w-32 bg-gray-200 rounded animate-pulse" />
          <div className="h-5 w-24 bg-gray-200 rounded animate-pulse" />
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {Array.from({ length: 8 }).map((_, index) => (
            <div 
              key={index} 
              className="p-3 border border-gray-200 rounded h-12 flex items-center justify-center"
              style={{
                animationDelay: `${index * 50}ms`, // Staggered skeleton appearance
              }}
            >
              <div className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
